import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import shopApi from '../services/shopApi';
import './OrderSuccessPage.css';

export default function OrderSuccessPage({ orderId: propOrderId }) {
  const [searchParams] = useSearchParams();
  const orderId = propOrderId || searchParams.get('orderId') || '';
  const [order, setOrder] = useState(null);

  useEffect(() => {
    if (!orderId) return;
    shopApi.getOrder(orderId).then(r => {
      if (r.success) setOrder(r.data?.order || r.data);
    }).catch(() => {});
  }, [orderId]);

  const formatDate = (d) => {
    if (!d) return '—';
    try { return new Date(d).toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }); }
    catch { return '—'; }
  };

  const formatPrice = (amount, currency = 'USD') => {
    if (!amount) return '—';
    try {
      return new Intl.NumberFormat('en-US', { style:'currency', currency: currency || 'USD' }).format(amount);
    } catch { return `${amount} ${currency}`; }
  };

  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-icon">✓</div>
        <div className="success-title">Order Placed!</div>
        <div className="success-sub">Thank you for your purchase. We're getting it ready.</div>

        {orderId && (
          <div className="order-id-box">
            <div className="order-id-label">Order Reference</div>
            <div className="order-id-val">{orderId}</div>
          </div>
        )}

        {order && (
          <div style={{ width:'100%', background:'rgba(0,229,204,0.04)', border:'1px solid rgba(0,229,204,0.1)', borderRadius:12, padding:'16px 20px', marginTop:16, textAlign:'left' }}>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8, fontSize:13, color:'rgba(224,240,240,0.5)' }}>
              <span>Date</span>
              <span style={{ color:'rgba(224,240,240,0.8)' }}>{formatDate(order.createdAt)}</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8, fontSize:13, color:'rgba(224,240,240,0.5)' }}>
              <span>Payment</span>
              <span style={{ color:'rgba(224,240,240,0.8)', textTransform:'uppercase' }}>{order.payment?.method || '—'}</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', marginBottom:12, fontSize:13, color:'rgba(224,240,240,0.5)' }}>
              <span>Status</span>
              <span style={{ color:'#00e5cc', fontWeight:600 }}>{order.status || 'confirmed'}</span>
            </div>
            {order.items?.length > 0 && (
              <div style={{ borderTop:'1px solid rgba(0,229,204,0.08)', paddingTop:12 }}>
                {order.items.map((item, i) => (
                  <div key={i} style={{ display:'flex', justifyContent:'space-between', fontSize:13, marginBottom:6 }}>
                    <span style={{ color:'rgba(224,240,240,0.7)' }}>{item.name} ×{item.quantity}</span>
                    <span style={{ color:'rgba(224,240,240,0.9)' }}>{formatPrice(item.price * item.quantity, item.currency)}</span>
                  </div>
                ))}
                <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, fontWeight:700, marginTop:8, paddingTop:8, borderTop:'1px solid rgba(0,229,204,0.08)' }}>
                  <span style={{ color:'rgba(224,240,240,0.6)' }}>Total</span>
                  <span style={{ color:'#00e5cc' }}>{formatPrice(order.total, order.currency)}</span>
                </div>
              </div>
            )}
          </div>
        )}

        <div className="success-steps">
          {[
            {ico:'📧', t:'Confirmation email on its way'},
            {ico:'✅', t:'Your items are authenticity verified'},
            {ico:'📦', t:'Preparing for dispatch'},
            {ico:'🚚', t:'Tracking info will be sent once shipped'},
          ].map(s => (
            <div key={s.t} className="success-step">
              <div className="ico">{s.ico}</div>
              {s.t}
            </div>
          ))}
        </div>

        <div className="success-btns">
          <Link to="/products" className="btn-primary" style={{padding:'12px 28px'}}>Continue Shopping →</Link>
          <Link to="/" className="btn-outline" style={{padding:'12px 28px'}}>Back to Home</Link>
        </div>
      </div>
    </div>
  );
}